<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
          </b-col>
        </b-row>
        <b-tabs>
          <b-tab title="Actie" active>
            <b-form @submit.prevent="saveItem">
              <b-row>
                <b-col>
                  <b-form-group label="Naam actie">
                    <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Type">
                    <b-form-select :options="actionTypes" required v-model="item.type" :disabled="!editable"></b-form-select>
                  </b-form-group>
                  <b-form-group label="Boodschap aan vrijwilligers">
                    <b-textarea rows="3" required v-model="item.introduction" :disabled="!editable"></b-textarea>
                  </b-form-group>
                  <b-form-group label="Datum en tijd">
                    <datetime v-model="item.datetime" type="datetime" :minute-step="15" :disabled="!editable" zone="UTC"></datetime>
                  </b-form-group>
                  <b-form-group label="Startpunt (verzamellocatie)">
                    <b-form-input type="text" required v-model="input" :disabled="!editable"/>
                    <b-list-group v-if="showList && suggestions">
                      <b-list-group-item
                        v-for="(suggestion, key) in suggestions.features"
                        :key="key"
                        @click="setPlace(suggestion)">
                          {{ transformSuggestion(suggestion) }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                  <b-form-group label="Gemeente">
                    <b-form-select :options="municipalityOptions" required v-model="item.municipality_id" :disabled="!editable"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-row>
                    <b-col>
                      <h5>Overig</h5>
                      <hr>
                      <b-form-group label="Campagne">
                        <b-form-select :options="questionnaireOptions" required v-model="item.questionnaire_id" :disabled="!editable"></b-form-select>
                      </b-form-group>
                      <b-form-group label="Doelstelling aantal gesprekken per deelnemer" hidden>
                        <b-form-input type="number" required v-model="item.participant_target" :disabled="!editable"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr>
                <div v-if="editable">
                  <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                  <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                </div>
                <div v-if="!editable">
                  <b-button type="button" @click.prevent="editable = true" variant="primary" class="mr-3 pull-right">Bewerken</b-button>
                </div>
                </b-col>
              </b-row>
            </b-form>
          </b-tab>
<!--          RESULTATEN     -->
          <b-tab title="Resultaten" :disabled="!item.action_ended">
            <h5 class="mb-3">Samenvatting</h5>
            <table class="table table-condensed">
              <tr class="table-success">
                <td><h5>Gesprekken</h5></td>
                <td><h5>{{item.results ? item.results.conversations : 0}}</h5></td>
              </tr>
              <tr class="table-primary">
                <td><h5>E-mailadressen</h5></td>
                <td><h5>{{item.results ? item.results.email : 0}}</h5></td>
              </tr>
              <tr class="table-danger">
                <td><h5>Geen interesse</h5></td>
                <td><h5>{{item.results ? item.results['no-interest'] : 0}}</h5></td>
              </tr>
              <tr class="table-warning">
                <td><h5>Afwezig</h5></td>
                <td><h5>{{item.results ? item.results.absent : 0}}</h5></td>
              </tr>
            </table>
            <h5 class="mt-4 mb-3">Opmerkingen vrijwilligers</h5>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Gebruiker</th>
                <th>Opmerking</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="remark in item.remarks">
                <td><a @click="$router.push({name: 'users.view', params: {id: remark.user_id}})" class="hoverable">{{remark.user}}</a></td>
                <td>{{remark.message}}</td>
              </tr>
              </tbody>
            </table>
            <hr>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
  import { updateData, getData, getMapboxPlaces } from '@/api';
  import { Datetime } from 'vue-datetime';

  export default {
    name: 'campaign-action',
    components: {Datetime},
    props: ['id'],
    data() {
      return {
        saveButtonDisabled: false,
        editable: false,
        item: {},
        actionTypes: [
          {
            text: 'Langs de deuren',
            value: 'door-to-door'
          },
          {
            text: 'In gesprek op 1 plek',
            value: 'fixed-location'
          },
        ],
        suggestions: undefined,
        place: undefined,
        placeName: '',
        municipalityOptions: [],
        questionnaireOptions: [],
        timeout: null,
        showList: false
      };
    },
    computed: {
      input: {
        get() {
          return this.placeName || this.item.address;
        },
        set(val) {
          if (this.timeout) {
            clearTimeout(this.timeout)
          }
          this.timeout = setTimeout(async () => {
            this.suggestions = await getMapboxPlaces(val);
            this.showList = true;
          }, 500);
        }
      }
    },
    methods: {
      setPlace(place) {
        this.place = place;
        this.placeName = this.transformSuggestion(place);
        this.showList = false;
      },
      transformSuggestion(suggestion) {
        const street = suggestion.text_NL;
        const houseNumber = suggestion.address || '';
        let postcode = '';
        let city = '';

        suggestion.context.map((value) => {
          if (value.id.includes('postcode')) {
            postcode = value.text_NL;
          }

          if (value.id.includes('place')) {
            city = value.text_NL;
          }
        });

        return houseNumber ? `${street} ${houseNumber}, ${postcode} ${city}` : `${street}, ${postcode} ${city}`;
      },
      async getItem() {
        this.item = await getData('campaign-actions/' + this.$route.params.id).then(
          (response) => response.data.data
        );
      },
      async getMunicipalityOptions() {
        this.municipalityOptions = await getData('municipalities').then(
          (response) => response.data.data
        );
      },
      async getQuestionnaireOptions() {
        this.questionnaireOptions = await getData('questionnaires?options=1').then(
          (response) => response.data.data
        );
      },
      async saveItem() {
        this.saveButtonDisabled = true;
        const [lng, lat] = this.place ? this.place.geometry.coordinates : [this.item.longitude, this.item.latitude];
        const request = await updateData(
          'campaign-actions/' + this.$route.params.id,
          {
            name: this.item.name,
            type: this.item.type,
            introduction: this.item.introduction,
            address: this.placeName || this.item.address,
            municipality_id: this.item.municipality_id,
            latitude: lat,
            longitude: lng,
            datetime: this.item.datetime,
            questionnaire_id: this.item.questionnaire_id,
            participant_target: this.item.participant_target,
          }
        );
        if (request.status === 200) {
          this.editable = false;
          this.saveButtonDisabled = false;
          await this.getItem();
        } else {
          this.editable = true;
          this.saveButtonDisabled = false;
        }
      },
      cancelEdit() {
        this.editable = false;
        this.getItem();
      },
    },
    beforeMount() {
      this.getItem();
      this.getMunicipalityOptions();
      this.getQuestionnaireOptions();
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
